/**
 * @module components/YAxisSetting/YAxisTopN
 * @description 条形图 Y 轴 TopN — 字段与 X 轴 TopN 共用 dynamicState/count/showOthers
 */
import React from 'react';
import { useIntl } from 'umi';
import TipContext from '@home/components/TipContext';
import TopNFieldGroup from '../common/TopNFieldGroup';
import { DEFAULT_HORIZONTAL_BAR_TOPN_COUNT } from '../../utils/constants';
import { useYAxisTopNDraftFields } from './useYAxisTopNDraftFields';
import '../XAxisSetting/XAxisTopN.scss';

const YAxisTopN: React.FC = () => {
  const { formatMessage } = useIntl();
  const topN = useYAxisTopNDraftFields(DEFAULT_HORIZONTAL_BAR_TOPN_COUNT, false);

  return (
    <div className="dbl-x-axis-topn">
      <div className="dbl-x-axis-topn__header">
        <span className="dbl-x-axis-topn__title">
          {formatMessage({ id: 'dbl_chart_top' })}
        </span>
        <TipContext
          tipText={formatMessage(
            { id: 'dbl_chart_topN_info' },
            { type: 'Y' },
          )}
        />
      </div>
      <TopNFieldGroup
        {...topN}
        countLimitTip={formatMessage({ id: 'dbl_myAnalysis_limit_100' })}
      />
    </div>
  );
};

export default React.memo(YAxisTopN);
